$(()=>{
  $('.fil-messaging fil-page-level-message').on('onclose', event => {
    let isShown = event.detail.value;
    if(!isShown){
      $(event.target).closest('.fil-messaging').addClass('hide');
    }
  });
});
